import { ImageLightbox } from "../ui/image-lightbox";
import type { ExpandedImagePreview } from "./ExpandedImagePreview";

interface ExpandedImageDialogProps {
  readonly preview: ExpandedImagePreview;
  readonly onClose: () => void;
}

/**
 * Chat's entry point into the shared image lightbox.
 *
 * The viewer that used to live here now lives in `ui/image-lightbox`, because
 * task attachments needed the same thing and a second near-identical viewer is
 * the duplication worth avoiding. This stays as a named seam so chat's nine
 * call sites keep reading in chat vocabulary; it carries no behaviour of its
 * own, and chat picks up zoom and pan for free.
 */
export function ExpandedImageDialog({ preview, onClose }: ExpandedImageDialogProps) {
  return <ImageLightbox preview={preview} onClose={onClose} />;
}
